<script setup lang="ts">
defineEmits<{ close: [] }>();
</script>

<template>
  <div
    class="relative px-4 py-6 border-b border-neutral300 h500 text-neutral1000"
  >
    <div class="h-6 flex items-center justify-center">
      <slot></slot>
    </div>
    <div class="absolute top-0 right-4 h-full flex flex-col justify-center">
      <button
        type="button"
        class="p-3 min-w-14 w-14 focus:outline-neutral1000"
        :aria-label="$t('global.close')"
        @click="$emit('close')"
      >
        <i class="far fa-times text-2xl"></i>
      </button>
    </div>
  </div>
</template>
